import { RootState } from 'duck/store'
import { connect } from 'react-redux'

import { hideFlashNoticeBegin, hideFlashNoticeEnd } from './duck/actions'
import { getAccessibleState } from './duck/types'
import FlashNotice from './presentational'

function mapStateToProps(state: RootState) {
  const flashContentQueue = getAccessibleState(state)
  const emptyQueue = flashContentQueue.length === 0
  if (emptyQueue) {
    return {
      open: false,
    }
  }
  const { show, message, variant, autoHide } = flashContentQueue[0]
  return {
    open: show,
    message,
    variant: variant || undefined,
    autoHide,
  }
}

export default connect(mapStateToProps, {
  onBeginClose: hideFlashNoticeBegin,
  onEndClose: hideFlashNoticeEnd,
})(FlashNotice)
